import type { QueryClient, QueryKey } from '@tanstack/react-query';

export const projectQueryKeys: QueryKey[] = [
  ['projects'], ['activeProjects'], ['completedProjects'],
];

export const projectMemberQueryKeys: QueryKey[] = [
  ['projectMembers'], ['myProjectMembers'],
];

export const timeEntryQueryKeys: QueryKey[] = [
  ['weekTimeEntries'], ['timeEntries'], ['managerWeekOverview'],
  ['myTeamTimeEntries'], ['allTimeEntries'], ['freeSelectionTimeEntries'],
  ['ownHoursReport'], ['activeProjects', 'report'], ['completedProjects', 'report'],
];

export async function refreshQueries(queryClient: QueryClient, queryKeys: QueryKey[]) {
  // Refresh previously visited pages too, rather than waiting for them to mount.
  await Promise.all(queryKeys.map((queryKey) =>
    queryClient.invalidateQueries({ queryKey, refetchType: 'all' })
  ));
}
